<template>
  <div>
    <section class="orep-header mont" v-if="['individual-appraiser-representation'].indexOf($route.name) < 0">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer'"  src="../../../public/assets/images/mercer-logo.png" class="logo" alt="Logo">
        <img v-else-if="getApplicantType ==='Realshield'"  src="../../../public/assets/images/realshield-logo-blue.png" class="logo" alt="Logo">
        <img v-else  src="../../../public/assets/images/OREPInsuranceShield_new.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase">CALIF. LIC. #0K99465</span>
      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "rx-application",
    computed: {

      rxApplication() {
        return this.$store.state.rxApplication.rxApplication;
      },
      state() {
        return this.$store.state.rxApplication;
      },
      errorMsg() {
        return this.$store.state.rxApplication.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/rx-application-amba' || first === '/portal/rx-application-amba/' || this.rxApplication.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/rx-application-realshield' || first === '/portal/rx-application-realshield/' || this.rxApplication.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
